/**
 * The designer's two-row header, shared by the floor planner and the 3D view.
 *
 *   Row 1 — the brand: the estimator nav bar's background (the same CSS
 *           variable, so a retailer's theme carries over), the logo, the
 *           view's name.
 *   Row 2 — the controls, centred, collapsing to icons when short of room
 *           (IconTextRow).
 *
 * Takes the brand as a plain prop (no context): the host reads the partner's
 * logo and passes it down, and tests can render the views without providers.
 */

import React from 'react';
import { IconTextRow } from './IconTextRow';
import './designerHeader.css';

export interface DesignerBrand {
  logoSrc: string;
  logoAlt: string;
}

export const DEFAULT_BRAND: DesignerBrand = { logoSrc: '/images/trusscore-colour-light.svg', logoAlt: 'Trusscore' };

export interface DesignerHeaderProps {
  title: string;
  brand?: DesignerBrand;
  /** Row 2: the controls, centred. */
  children?: React.ReactNode;
  /** Row 2, far right (Exit, close). */
  end?: React.ReactNode;
}

export const DesignerHeader: React.FC<DesignerHeaderProps> = ({ title, brand = DEFAULT_BRAND, children, end }) => (
  <div className="dh">
    <div className="dh-brand">
      <img className="dh-logo" src={brand.logoSrc} alt={brand.logoAlt} />
      <span className="dh-title">{title}</span>
    </div>
    <IconTextRow end={end}>{children}</IconTextRow>
  </div>
);

export default DesignerHeader;
